module.exports = __webpack_public_path__ + "static/media/six-life-bg.53ac343f.svg";